var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardDoubleArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.2925 0.293763C-0.0975 0.683763 -0.0975 1.31376 0.2925 1.70376L4.1725 5.58376L0.2925 9.46376C-0.0975 9.85376 -0.0975 10.4838 0.2925 10.8738C0.6825 11.2638 1.3125 11.2638 1.7025 10.8738L6.2925 6.28376C6.6825 5.89376 6.6825 5.26376 6.2925 4.87376L1.7125 0.293763C1.3225 -0.0962373 0.6825 -0.0962373 0.2925 0.293763Z",
    fill: "#3B4149"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88253 0.293762C6.49253 0.683762 6.49253 1.31376 6.88253 1.70376L10.7625 5.58376L6.88253 9.46376C6.49253 9.85376 6.49253 10.4838 6.88253 10.8738C7.27253 11.2638 7.90253 11.2638 8.29253 10.8738L12.8825 6.28376C13.2725 5.89376 13.2725 5.26376 12.8825 4.87376L8.29253 0.283762C7.91253 -0.0962379 7.27253 -0.0962377 6.88253 0.293762Z",
    fill: "#3B4149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardDoubleArrowRightIcon);
export default __webpack_public_path__ + "static/media/keyboardDoubleArrowRightIcon.bbc138fe.svg";
export { ForwardRef as ReactComponent };